/**
 * Shopify Theme Asset: assets/product-flow-finder.js
 * Client-side script for Shopify Online Store 2.0 Product Flow Finder
 */

(function() {
  'use strict';

  const DEFAULT_DATA = {
    columns: [
      { id: 'format', title: 'Format' },
      { id: 'category', title: 'Category' },
      { id: 'product_type', title: 'Types of Products' },
      { id: 'product_code', title: 'Personalize' }
    ],
    items: [
      // Format
      { id: 'f_card', columnId: 'format', title: 'Card' },
      { id: 'f_poster', columnId: 'format', title: 'Poster with Audio' },
      { id: 'f_coloring', columnId: 'format', title: 'Coloring Activity' },
      // Category
      { id: 'c_connection', columnId: 'category', title: 'Connection' },
      { id: 'c_movement', columnId: 'category', title: 'Movement' },
      { id: 'c_sleep', columnId: 'category', title: 'Sleep' },
      // Product Types
      { id: 'p_car_travel', columnId: 'product_type', title: 'Car and Travel Conversation Cards' },
      { id: 'p_naturewalk', columnId: 'product_type', title: 'Naturewalk Cards' },
      { id: 'p_mealtime', columnId: 'product_type', title: 'Mealtime Cards' },
      { id: 'p_yoga_cards', columnId: 'product_type', title: 'Yoga Cards' },
      { id: 'p_breathing_cards', columnId: 'product_type', title: 'Breathing Cards' },
      { id: 'p_audio_yoga', columnId: 'product_type', title: 'Audio Yoga Guide' },
      { id: 'p_bedtime_stories', columnId: 'product_type', title: 'Bedtime Audio Stories' },
      { id: 'p_bedtime_books', columnId: 'product_type', title: 'Bedtime Coloring Books' },
      // Product Codes
      { id: 'sku_hw_c_004', columnId: 'product_code', title: 'HW-C-004', code: 'HW-C-004', productHandle: 'personalized-car-and-travel-conversation-starters', title1: 'Personalized Car and Travel Prompt Cards' },
      { id: 'sku_hw_c_005', columnId: 'product_code', title: 'HW-C-005', code: 'HW-C-005', productHandle: 'personalized-naturewalk-conversation-starters', title1: 'Personalized Naturewalk Prompt Cards' },
      { id: 'sku_hw_c_006', columnId: 'product_code', title: 'HW-C-006', code: 'HW-C-006', productHandle: 'personalized-mealtime-conversation-starters', title1: 'Personalized Car and Travel Prompt Cards' },
      { id: 'sku_hw_m_016', columnId: 'product_code', title: 'H&W-M-016', code: 'H&W-M-016', productHandle: 'personalized-yoga-cards-bundle-yoga-flashcards-personalized-photo-and-name-per-card', title1: 'Personalized Yoga Cards Bundle -Yoga Flashcards' },
      { id: 'sku_hw_m_015', columnId: 'product_code', title: 'H&W-M-015', code: 'H&W-M-015', productHandle: 'personalized-breathing-cards-bundle-breathing-flashcards-personalized-photo-and-name-per-card', title1: 'Personalized Breathing Cards Bundle - Breathing Flashcards' },
      { id: 'sku_hw_m_017', columnId: 'product_code', title: 'H&W-M-017', code: 'H&W-M-017', productHandle: 'audio-yoga-bundle-all-12-titles-personalized-guided-yoga-audio', title1: 'Audio Yoga Bundle' },
      { id: 'sku_hw_s_013', columnId: 'product_code', title: 'HW-S-013', code: 'HW-S-013', productHandle: 'sleep-audiobook-bundle-all-12-titles-personalized-bedtime-audio-stories', title1: 'Sleep Audiobook Bundle' },
      { id: 'sku_hw_s_018', columnId: 'product_code', title: 'HW-S-018', code: 'HW-S-018', productHandle: 'dreams-and-passions-personalized-bedtime-coloring-activity-bundle', title1: 'Dreams and Passions' },
      { id: 'sku_hw_s_019', columnId: 'product_code', title: 'HW-S-019', code: 'HW-S-019', productHandle: 'custom-wooden-storybook-box', title1: 'Personalized Car and Travel Prompt Cards ' },
      { id: 'sku_hw_s_020', columnId: 'product_code', title: 'HW-S-020', code: 'HW-S-020', productHandle: 'magic-and-fantasy-personalized-bedtime-coloring-activity-bundle', title1: 'Magical Adventure' },
      { id: 'sku_hw_s_021', columnId: 'product_code', title: 'HW-S-021', code: 'HW-S-021', productHandle: 'space-and-tech-adventures-personalized-bedtime-coloring-activity-bundle', title1: 'Tech Adventures' },
      { id: 'sku_hw_s_022', columnId: 'product_code', title: 'HW-S-022', code: 'HW-S-022', productHandle: 'superheroes-super-adventures-personalized-bedtime-coloring-activity-bundle', title1: 'Super Adventures' }
    ],
    connections: [
      { from: 'f_card', to: 'c_connection' },
      { from: 'f_card', to: 'c_movement' },
      { from: 'f_poster', to: 'c_movement' },
      { from: 'f_coloring', to: 'c_sleep' },
      { from: 'c_connection', to: 'p_car_travel' },
      { from: 'c_connection', to: 'p_naturewalk' },
      { from: 'c_connection', to: 'p_mealtime' },
      { from: 'c_movement', to: 'p_yoga_cards' },
      { from: 'c_movement', to: 'p_breathing_cards' },
      { from: 'c_movement', to: 'p_audio_yoga' },
      { from: 'c_sleep', to: 'p_bedtime_stories' },
      { from: 'c_sleep', to: 'p_bedtime_books' },
      { from: 'p_car_travel', to: 'sku_hw_c_004' },
      { from: 'p_naturewalk', to: 'sku_hw_c_005' },
      { from: 'p_mealtime', to: 'sku_hw_c_006' },
      { from: 'p_yoga_cards', to: 'sku_hw_m_016' },
      { from: 'p_breathing_cards', to: 'sku_hw_m_015' },
      { from: 'p_audio_yoga', to: 'sku_hw_m_017' },
      { from: 'p_bedtime_stories', to: 'sku_hw_s_013' },
      { from: 'p_bedtime_books', to: 'sku_hw_s_018' },
      { from: 'p_bedtime_books', to: 'sku_hw_s_019' },
      { from: 'p_bedtime_books', to: 'sku_hw_s_020' },
      { from: 'p_bedtime_books', to: 'sku_hw_s_021' },
      { from: 'p_bedtime_books', to: 'sku_hw_s_022' }
    ]
  };

  class ShopifyProductFlowInstance {
    constructor(config) {
      this.container = document.getElementById(config.containerId);
      if (!this.container) return;

      this.customizerUrl = config.customizerUrl || '/pages/personalize';
      this.currentView = config.defaultView || 'visual';
      this.data = DEFAULT_DATA;
      this.selectedNodeId = null;

      this.render();
    }

    render() {
      this.container.innerHTML = `
        <div class="spf-canvas-viewport">
          <div class="spf-canvas-inner" id="spf-canvas-inner">
            <svg class="spf-svg-layer" id="spf-svg"></svg>
            <div class="spf-columns-grid" id="spf-grid"></div>
          </div>
          <div class="section_prd_btn_block">
            <a href="/collections" class="section_prd_btn">
              <span>Start building your routine</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="4" viewBox="0 0 11 4" fill="none">
              <path d="M7.76506 3.90603C7.88906 3.61669 8.01822 3.35319 8.15256 3.11553C8.28689 2.87786 8.42639 2.66603 8.57106 2.48003H-0.000445157V1.42603H8.57106C8.42639 1.24003 8.28689 1.02819 8.15256 0.790528C8.01822 0.542528 7.88906 0.279028 7.76506 2.79397e-05H8.71056C9.35122 0.754361 10.0436 1.31753 10.7876 1.68953V2.21653C10.0539 2.57819 9.36156 3.14136 8.71056 3.90603H7.76506Z" fill="#111111"></path>
              </svg>
            </a>
          </div>
        </div>
      `;

      this.renderColumns();
      this.renderSvgLines();
      window.addEventListener('resize', () => this.renderSvgLines());
    }

    renderColumns() {
      const grid = this.container.querySelector('#spf-grid');
      grid.innerHTML = '';

      this.data.columns.forEach((col, colIdx) => {
        const colDiv = document.createElement('div');
        colDiv.className = 'spf-column';
        colDiv.setAttribute('data-col', col.id);

        colDiv.innerHTML = `
          <div class="spf-column-title">${col.title}</div>
          <div class="spf-items-stack" id="spf-stack-${col.id}"></div>
        `;

        const stack = colDiv.querySelector(`#spf-stack-${col.id}`);
        const items = this.data.items.filter(i => i.columnId === col.id);
        //console.log(items);
        items.forEach(item => {
          const card = document.createElement('div');
          card.className = 'spf-node-card';
          card.id = `spf-node-${item.id}`;
          card.setAttribute('data-id', item.id);
          card.setAttribute('data-col', col.id);

          if (col.id === 'product_code') {
            const destUrl = `${this.customizerUrl}?product=${item.productHandle || ''}&sku=${encodeURIComponent(item.code || item.title)}`;
            card.innerHTML = `
              
              <a href="${destUrl}" class="spf-btn-personalize">${item.title1}</a>
            `;
          } else {
            card.innerHTML = `<span>${item.title}</span>`;
          }

          // Ports
          if (colIdx > 0) {
            const inPort = document.createElement('div');
            inPort.className = 'spf-port port-left';
            inPort.id = `spf-port-in-${item.id}`;
            card.appendChild(inPort);
          }

          if (colIdx < this.data.columns.length - 1) {
            if (item.id === 'p_bedtime_books') {
              for (let k = 0; k < 5; k++) {
                const outPort = document.createElement('div');
                outPort.className = 'spf-port port-right';
                outPort.id = `spf-port-out-${item.id}-${k}`;
                outPort.setAttribute('data-offset-index', k);
                card.appendChild(outPort);
              }
            } else {
              const outPort = document.createElement('div');
              outPort.className = 'spf-port port-right';
              outPort.id = `spf-port-out-${item.id}`;
              card.appendChild(outPort);
            }
          }

          card.addEventListener('click', (e) => {
            if (e.target.closest('.spf-btn-personalize')) return;
            this.handleNodeClick(item.id);
          });

          stack.appendChild(card);
        });

        grid.appendChild(colDiv);
      });
    }

    renderSvgLines() {
      const svg = this.container.querySelector('#spf-svg');
      if (!svg) return;
      svg.innerHTML = '';

      const svgRect = svg.getBoundingClientRect();
      let bedtimeIndex = 0;

      this.data.connections.forEach(conn => {
        let fromPort = null;
        if (conn.from === 'p_bedtime_books') {
          fromPort = this.container.querySelector(`#spf-port-out-${conn.from}-${bedtimeIndex % 5}`);
          bedtimeIndex++;
        } else {
          fromPort = this.container.querySelector(`#spf-port-out-${conn.from}`);
        }

        const toPort = this.container.querySelector(`#spf-port-in-${conn.to}`);
        if (!fromPort || !toPort) return;

        const fRect = fromPort.getBoundingClientRect();
        const tRect = toPort.getBoundingClientRect();

        const x1 = fRect.left + fRect.width / 2 - svgRect.left;
        const y1 = fRect.top + fRect.height / 2 - svgRect.top;
        const x2 = tRect.left + tRect.width / 2 - svgRect.left;
        const y2 = tRect.top + tRect.height / 2 - svgRect.top;

        const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        line.setAttribute('d', `M ${x1} ${y1} L ${x2} ${y2}`);
        line.setAttribute('class', 'spf-line');
        line.setAttribute('data-from', conn.from);
        line.setAttribute('data-to', conn.to);

        if (this.selectedNodeId) {
          const path = this.getFullPath(this.selectedNodeId);
          if (path.connections.has(`${conn.from}->${conn.to}`)) {
            line.classList.add('highlighted');
          } else {
            line.classList.add('dimmed');
          }
        }

        svg.appendChild(line);
      });
    }

    handleNodeClick(nodeId) {
      if (this.selectedNodeId === nodeId) {
        this.selectedNodeId = null;
      } else {
        this.selectedNodeId = nodeId;
      }

      const allCards = this.container.querySelectorAll('.spf-node-card');
      if (!this.selectedNodeId) {
        allCards.forEach(c => c.classList.remove('selected', 'highlighted', 'dimmed'));
      } else {
        const path = this.getFullPath(this.selectedNodeId);
        allCards.forEach(c => {
          const cId = c.getAttribute('data-id');
          c.classList.remove('selected', 'highlighted', 'dimmed');
          if (cId === this.selectedNodeId) c.classList.add('selected');
          else if (path.nodes.has(cId)) c.classList.add('highlighted');
          else c.classList.add('dimmed');
        });
      }

      this.renderSvgLines();
    }

    getFullPath(nodeId) {
      const nodes = new Set([nodeId]);
      const connections = new Set();

      const qDown = [nodeId];
      while (qDown.length > 0) {
        const cur = qDown.shift();
        this.data.connections.filter(c => c.from === cur).forEach(c => {
          connections.add(`${c.from}->${c.to}`);
          if (!nodes.has(c.to)) {
            nodes.add(c.to);
            qDown.push(c.to);
          }
        });
      }

      const qUp = [nodeId];
      while (qUp.length > 0) {
        const cur = qUp.shift();
        this.data.connections.filter(c => c.to === cur).forEach(c => {
          connections.add(`${c.from}->${c.to}`);
          if (!nodes.has(c.from)) {
            nodes.add(c.from);
            qUp.push(c.from);
          }
        });
      }

      return { nodes, connections };
    }
  }

  window.ShopifyProductFlowFinder = {
    init: function(config) {
      return new ShopifyProductFlowInstance(config);
    }
  };
})();
